export interface MarketingNavLink {
	title: string;
	href: string;
	description?: string;
	external?: boolean;
}

export interface MarketingNavSection extends MarketingNavLink {
	items?: MarketingNavLink[];
}

export const marketing_nav_sections: MarketingNavSection[] = [
	{
		title: "Platform",
		href: "/platform",
		items: [
			{
				title: "Platform overview",
				href: "/platform",
				description: "The full StudyStash workflow across content, practice, feedback, and insight."
			},
			{
				title: "Adaptive Learning",
				href: "/how-we-help/adaptive-learning",
				description: "Personalised study support shaped around each learner's progress."
			},
			{
				title: "AI with Guardrails",
				href: "/how-we-help/ai-with-guardrails",
				description: "Responsible, course-grounded AI with institutional oversight."
			},
			{
				title: "Learner Insights",
				href: "/how-we-help/learner-insights",
				description: "Engagement and comprehension signals for earlier intervention."
			},
			{
				title: "LMS Integrations",
				href: "/lms-integrations",
				description: "LTI 1.3 support for Canvas, Moodle, Blackboard, D2L, and more."
			}
		]
	},
	{
		title: "Why StudyStash?",
		href: "/why-studystash",
		items: [
			{
				title: "Why StudyStash?",
				href: "/why-studystash",
				description: "Benefits across engagement, feedback, accessibility, and workload."
			},
			{
				title: "Responsible AI",
				href: "/trustworthy-and-responsible-ai",
				description: "How StudyStash approaches trustworthy and responsible AI."
			},
			{
				title: "How we compare",
				href: "/how-we-compare",
				description: "Where StudyStash fits against other learning and AI tools."
			}
		]
	},
	{
		title: "Case studies",
		href: "/case-studies",
		items: [
			{
				title: "All case studies",
				href: "/case-studies",
				description: "Institution deployments and student stories in one place."
			},
			{
				title: "Institutions",
				href: "/case-studies?tab=institutions",
				description: "University, college, and school stories."
			},
			{
				title: "Students",
				href: "/case-studies?tab=students",
				description: "Learner stories and testimonials."
			},
			{
				title: "News & Insights",
				href: "/news-insights",
				description: "Articles, events, and company updates."
			}
		]
	},
	{
		title: "About",
		href: "/about/our-story",
		items: [
			{
				title: "Our Story",
				href: "/about/our-story",
				description: "The StudyStash founding story, team, and awards."
			},
			{
				title: "Roadmap",
				href: "/roadmap",
				description: "A high-level view of where the product is heading."
			},
			{
				title: "Trust Centre",
				href: "https://trust.studystash.com",
				description: "Security, compliance, and trust resources.",
				external: true
			},
			{
				title: "Help Centre",
				href: "https://internal.support.studystash.com/servicedesk/customer/portals",
				description: "Support resources and customer help.",
				external: true
			}
		]
	},
	{
		title: "Pricing",
		href: "/pricing"
	}
];

export const marketing_footer_groups = [
	{
		title: "Platform",
		items: [
			{ title: "Platform", href: "/platform" },
			{ title: "Adaptive Learning", href: "/how-we-help/adaptive-learning" },
			{ title: "AI with Guardrails", href: "/how-we-help/ai-with-guardrails" },
			{ title: "Learner Insights", href: "/how-we-help/learner-insights" },
			{ title: "LMS Integrations", href: "/lms-integrations" }
		]
	},
	{
		title: "Case studies",
		items: [
			{ title: "All case studies", href: "/case-studies" },
			{ title: "Institutions", href: "/case-studies?tab=institutions" },
			{ title: "Students", href: "/case-studies?tab=students" },
			{ title: "News & Insights", href: "/news-insights" }
		]
	},
	{
		title: "About",
		items: [
			{ title: "Our Story", href: "/about/our-story" },
			{ title: "Roadmap", href: "/roadmap" },
			{ title: "Trust Centre", href: "https://trust.studystash.com/", external: true },
			{ title: "Help Centre", href: "https://internal.support.studystash.com/servicedesk/customer/portals", external: true }
		]
	},
	{
		title: "Find out more",
		items: [
			{ title: "Pricing", href: "/pricing" },
			{ title: "Book a Demo", href: "/book-a-demo" },
			{ title: "Sign up", href: "/register" },
			{ title: "Login", href: "/login" },
			{ title: "Contact Us", href: "/contact-us" }
		]
	}
];
